
    import Pdfh5 from "pdfh5";
    import "pdfh5/css/pdfh5.css";
    import { defineComponent, computed, ComputedRef, reactive,  onMounted, nextTick} from "vue";
    import {useRoute} from "vue-router";
    import {useStore} from "@/store";
    export default defineComponent({
        name: "PdfView",
        setup() {
            let state = reactive({
                pdfh5: null
            });
            const {query} = useRoute();
            // let store = useStore()
            // let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            const pdfurl: string | null = query.pdfurl as string;

            // const { reportConfigInfo } = dataInfo.value as any
            onMounted(() => {
                state.pdfh5 = new Pdfh5("#pdf", {
                    pdfurl: decodeURIComponent(pdfurl)
                });
            });
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            }
        }
    });
